import * as actions from './avisos.action';
import inicialState from './avisos.state';

const avisosReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ATUALIZAR_AVISO:
      return {
        ...state,
        mensagem: action.payload.mensagem,
      };

    default:
      return state;
  }
};

export default avisosReducer;



// WEBPACK FOOTER //
// ./src/app/common/avisos/avisos.reducer.js